import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _regeneratorRuntime from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import { env, corpId, AgentId, yxwlSysCode, yxwlScrect, addressUrl, sysCode, baseUrl, mdUrl, buriedEnv, buriedScrect, contractShareUrl, wxAppId, mpAppId, newWxAppId, yxwlAddressShareUrl } from '@/config';
import SPMDSDK from '@fe/sp-md-web-sdk';
import { initApi } from '@/api/init';
import { encodeBase64, decodeBase64 } from '@/utils/index';
import { getUserId } from "./init";
import router from '@/router';

/**
 * [获取URL中的参数名及参数值的集合]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param {[string]} urlStr [当该参数不为空的时候，则解析该url中的参数集合]
 * @return {[string]}       [参数集合]
 */
export function GetRequest(urlStr) {
  var url;
  var group = urlStr.split('?');
  var address;
  if (group.length == 2) {
    address = group[1];
  } else if (group.length == 3) {
    address = group[2];
  }
  if (typeof urlStr === 'undefined') {
    url = decodeURI(location.search); // 获取url中"?"符后的字符串
  } else {
    url = '?' + address;
  }
  var theRequest = new Object();
  if (url.indexOf('?') != -1) {
    var str = url.substr(1);
    var strs = str.split('&');
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}

/**
 * @description:// 初始化埋点sdk
 * **/
var initState = 0;
export function initMD(val) {
  if (initState) {
    return;
  }
  return new Promise(function (resolve, reject) {
    SPMDSDK.init({
      serverUrl: mdUrl,
      sysCode: yxwlSysCode,
      secret: yxwlScrect,
      env: buriedEnv,
      // 大写D－T－P
      planner_id_sp: JSON.parse(localStorage.getItem('mchInfo')).mchUserId,
      //商户用户ID
      user_id_sp: JSON.parse(localStorage.getItem('userId')),
      //用户ID
      // share_id_sp:JSON.parse(localStorage.getItem('userId')),//用户ID
      buriedPointReportingMode: sysCode,
      token: localStorage.getItem('token'),
      user_type_code_sp: '2',
      share_user_type_code_sp: '2',
      is_login_sp: localStorage.getItem('userId') ? 1 : 0 //0-未登录,1-已登录
    }).then(function (res) {
      // 初始化成功开始埋点
      console.log('初始化埋点成功', res);
      initState = 1;
      resolve({
        code: 200,
        data: res
      });
    }).catch(function (error) {
      console.log('--------error:埋点初始化失败----------');
      console.log('初始化埋点失败', error);
      reject({
        code: 500,
        err: error
      });
    });
  });
}

/**
 * @description:点击发送埋点
 * @params:{code}-埋点对应code
 * @params:{eventSp}-埋点对应事件名
 * @params:{typeSp}-埋点对应事件显示名
 * @params:{id}-埋点对应内容ID
 * **/
// 浏览页面埋点操作
export function scanPage(code, eventSp, typeSp, id, page_name_sp, track_name_sp, event_name_sp) {
  return new Promise(function (resolve, reject) {
    SPMDSDK.spTrack({
      track_code_sp: code,
      track_name_sp: track_name_sp,
      //埋点名称
      event_sp: eventSp,
      //事件名英文
      event_name_sp: event_name_sp,
      //事件名中文
      content_type_sp: typeSp,
      content_id_sp: id,
      page_name_sp: page_name_sp //页面名称
    }).then(function (res) {
      console.log('--------页面浏览:埋点成功----------', res);
    }).catch(function (error) {
      console.log('--------页面浏览:埋点失败----------');
      console.log('埋点失败', error);
    });
  });
}

/**
 * @description:搜说埋点
 * @params:{code}-埋点对应code
 * @params:{eventSp}-埋点对应事件名
 * @params:{typeSp}-埋点对应事件显示名
 * **/
// 浏览页面埋点操作
export function searcMd(code, eventSp, keywordType, keyword, page_name_sp, track_name_sp, event_name_sp, version) {
  return new Promise(function (resolve, reject) {
    var timestamp = Date.parse(new Date());
    SPMDSDK.spTrack({
      track_code_sp: code,
      track_name_sp: track_name_sp,
      // 埋点名称
      event_sp: eventSp,
      // 事件名英文
      event_name_sp: event_name_sp,
      // 事件名中文
      keyword_type_sp: keywordType,
      keyword_sp: keyword,
      page_name_sp: page_name_sp,
      // 页面名称
      app_version_sp: version,
      // 版本号
      event_time_sp: timestamp // 当前时间
    }).then(function (res) {
      console.log('--------搜索:埋点成功----------', res);
    }).catch(function (error) {
      console.log('--------搜索:埋点失败----------');
      console.log('埋点失败', error);
    });
  });
}

/**
 * @description:点击发送埋点
 * @params:{code}-埋点对应code
 * @params:{eventSp}-埋点对应事件名
 * @params:{typeSp}-埋点对应事件显示名
 * @params:{id}-埋点对应内容ID
 * **/
// 浏览页面埋点操作
export function scanPageAndVersion(code, eventSp, page_name_sp, track_name_sp, event_name_sp, version) {
  return new Promise(function (resolve, reject) {
    var timestamp = Date.parse(new Date());
    SPMDSDK.spTrack({
      track_code_sp: code,
      track_name_sp: track_name_sp,
      // 埋点名称
      event_sp: eventSp,
      // 事件名英文
      event_name_sp: event_name_sp,
      // 事件名中文
      page_name_sp: page_name_sp,
      // 页面名称
      app_version_sp: version,
      // 版本号
      event_time_sp: timestamp // 当前时间
    }).then(function (res) {
      console.log('--------页面浏览:埋点成功----------', res);
    }).catch(function (error) {
      console.log('--------页面浏览:埋点失败----------');
      console.log('埋点失败', error);
    });
  });
}

/**
 * @description:点击发送埋点
 * @params:{code}-埋点对应code
 * @params:{eventSp}-埋点对应事件名
 * @params:{typeSp}-埋点对应事件显示名
 * @params:{id}-埋点对应内容ID
 * **/
// 分享埋点操作
export function sharePage(code, eventSp, typeSp, share_action_id_sp, track_name_sp, event_name_sp, page_name_sp, content_name_sp, mchUserId) {
  return new Promise(function (resolve, reject) {
    console.log({
      track_code_sp: code,
      track_name_sp: track_name_sp,
      //埋点名称
      event_sp: eventSp,
      //事件名英文
      event_name_sp: event_name_sp,
      //事件名中文
      content_type_sp: typeSp,
      is_share_action_id_sp: share_action_id_sp,
      share_action_id_sp: share_action_id_sp,
      page_name_sp: page_name_sp,
      //页面名称
      content_name_sp: content_name_sp,
      //用户名称userName
      planner: mchUserId //规划师ID
    });
    SPMDSDK.spTrack({
      track_code_sp: code,
      track_name_sp: track_name_sp,
      //埋点名称
      event_sp: eventSp,
      //事件名英文
      event_name_sp: event_name_sp,
      //事件名中文
      content_type_sp: typeSp,
      is_share_action_id_sp: share_action_id_sp,
      share_action_id_sp: share_action_id_sp,
      page_name_sp: page_name_sp,
      //页面名称
      content_name_sp: content_name_sp,
      //用户名称userName
      planner: mchUserId //规划师ID
    }).then(function (res) {
      console.log('--------页面浏览:埋点成功----------', res);
    }).catch(function (error) {
      console.log('--------页面浏览:埋点失败----------');
      console.log('埋点失败', error);
    });
  });
}

/**
 * @description:生成分享链接地址
 * @params{}:此操作是带上分享人ID，方便大数据统计
 * @params{url}:分享链接
 */
export function createShareUrl(item, eventSp, elementName, eventName, contentName, code, type, path, pageName, shareTypeSp) {
  console.log('1', contentName);
  var share_url_sp = addressUrl + '#/' + path;
  // console.log('分享地址', pageName)
  // console.log('SDK',SPMDSDK)
  // this.createShareUrl(shareUrl)
  SPMDSDK.createShareUrl({
    share_url_sp: share_url_sp
  }).then(function (res) {
    // 获取到返回的json数据 案例如：
    console.log('埋点信息', res);
    breakPoint(item, eventSp, elementName, eventName, contentName, code, type, res.data.share_action_id_sp, res.data.share_id_sp, pageName, shareTypeSp);
  }).catch(function (error) {
    // 上报失败后执行代码片段
    console.log('埋点失败', error);
  });
}

/**
 * @description：手动埋点
 * **/

export function breakPoint(item, eventSp, elementName, eventName, contentName, code, type, share_action_id_sp, share_id_sp, pageName, shareTypeSp) {
  console.log('eventName', pageName, contentName);

  // 页面埋点
  try {
    SPMDSDK.spTrack({
      event_sp: eventSp,
      element_name_sp: elementName,
      event_name_sp: eventName,
      content_name_sp: contentName,
      page_name_sp: pageName,
      //页面名称
      track_code_sp: code,
      track_name_sp: elementName,
      content_type_sp: type,
      content_id_sp: item.id,
      is_share_type_sp: shareTypeSp ? shareTypeSp : '企业微信',
      share_action_id_sp: share_action_id_sp,
      // 分享动作id:唯一随机数
      is_share_action_id_sp: share_action_id_sp,
      // 分享动作id:唯一随机数
      share_id_sp: share_id_sp,
      // 分享id，如果用户登陆了就是用户id，未登录取值匿名id
      content_level_1_code_sp: item.oneClassificationId ? item.oneClassificationId : '',
      content_level_1_sp: item.oneClassification ? item.oneClassification : '',
      received_user_type_sp: '普通用户',
      received_user_id_sp: localStorage.getItem('externalUserId') //外部联系人ID
      // share_action_id_sp:share_action_id_sp,//分享动作id:唯一随机数
      // share_id_sp:share_id_sp,//分享id，如果用户登陆了就是用户id，未登录取值匿名id
    }).then(function (res) {
      // console.log('手动成功',res)
    });
  } catch (error) {
    console.log(error);
  }
}
var JS_API_LIST = ['getContext', 'getCurExternalContact', 'openUserProfile', 'openEnterpriseChat', 'openExistedChatWithMsg', 'sendChatMessage', 'openUserProfile'];

/**config注入的是企业的身份与权限**/

export var initConfig = function initConfig() {
  return new Promise(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var res, timestamp, nonceStr, signature, _corpId;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return initApi.getConfig();
          case 3:
            res = _context2.sent;
            console.log('企业rews', res);
            timestamp = res.timestamp, nonceStr = res.nonceStr, signature = res.signature, _corpId = res.corpId;
            wx.config({
              beta: true,
              debug: false,
              appId: _corpId,
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: signature,
              jsApiList: JS_API_LIST
            });
            wx.ready(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var resData, timestamp, nonceStr, signature, corpId, AgentId;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return initApi.getAgentConfig();
                  case 2:
                    resData = _context.sent;
                    console.log('应用rews', resData);
                    timestamp = resData.timestamp, nonceStr = resData.nonceStr, signature = resData.signature, corpId = resData.corpId, AgentId = resData.AgentId;
                    wx.agentConfig({
                      corpid: corpId,
                      agentid: AgentId,
                      timestamp: timestamp,
                      nonceStr: nonceStr,
                      signature: signature,
                      jsApiList: JS_API_LIST,
                      success: function success(data) {
                        console.log('aginit成功', data);
                        // getUserId()
                        resolve(data);
                      },
                      fail: function fail(err) {
                        console.log('aginit失败', err);
                        if (err.errMsg.indexOf('function not exist') > -1) {
                          alert('版本过低请升级');
                        }
                        reject(err);
                      }
                    });
                  case 6:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })));
            wx.error(function () {
              // alert('false')
              console.log('企业失败');
              reject(false);
            });
            _context2.next = 14;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](0);
            reject(_context2.t0);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

/**agentConfig注入的是应用的身份与权限**/

export var initAgentConfig = function initAgentConfig() {
  return new Promise(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
      var res, timestamp, nonceStr, signature, _corpId2, _AgentId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return initApi.getAgentConfig();
          case 3:
            res = _context4.sent;
            timestamp = res.timestamp, nonceStr = res.nonceStr, signature = res.signature, _corpId2 = res.corpId, _AgentId = res.AgentId;
            wx.agentConfig({
              corpid: _corpId2,
              agentid: _AgentId,
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: signature,
              jsApiList: JS_API_LIST,
              success: function success(data) {
                return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        console.log('aginit成功', data);
                        // await getUserId()

                        resolve(data);
                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }))();
              },
              fail: function fail(err) {
                // console.log('aginit失败', err)
                if (err.errMsg.indexOf('function not exist') > -1) {
                  alert('版本过低请升级');
                }
                reject(err);
              }
            });
            _context4.next = 11;
            break;
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            // console.log('aginit失败2', error)
            reject(_context4.t0);
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 8]]);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }());
};

//禁止页面滑动
export var noSliding = function noSliding(e) {
  e.preventDefault();
};
/**
 * @description:测试建群发消息
 * **/
export function shareText(_x5, _x6, _x7) {
  return _shareText.apply(this, arguments);
}
/**
 * @description:分享-图片发送
 * **/
function _shareText() {
  _shareText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(item, type, code) {
    var entry, chatIdText, resData, timestamp, nonceStr, signature, corpId, AgentId;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return initApi.getAgentConfig();
        case 2:
          resData = _context5.sent;
          console.log(resData, 'resData');
          // console.log('getAgentConfig接口响应数据', resData)
          timestamp = resData.timestamp, nonceStr = resData.nonceStr, signature = resData.signature, corpId = resData.corpId, AgentId = resData.AgentId;
          wx.agentConfig({
            corpid: corpId,
            agentid: AgentId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: JS_API_LIST,
            success: function success(data) {
              // console.log('AgentConfig注册成功', data)
              wx.checkJsApi({
                jsApiList: ['getContext', 'openEnterpriseChat', 'openExistedChatWithMsg'],
                // 需要检测的JS接口列表
                success: function success(res) {
                  // console.log('检测结果', res)
                  // 以键值对的形式返回，可用的api值true，不可用为false
                  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                  if (res.errMsg == 'checkJsApi:ok') {
                    wx.invoke('getContext', {}, function (res) {
                      // console.log('判断入口', res)
                      if (res.err_msg == 'getContext:ok') {
                        entry = res.entry; // 返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
                        console.log(res, 'eeeeeeeeentry');
                        // shareTicket = res.shareTicket // 可用于调用getShareInfo接口
                      } else {
                        // 错误处理
                      }
                    });
                    wx.openEnterpriseChat({
                      // 注意：userIds和externalUserIds至少选填一个。内部群最多2000人；外部群最多500人；如果有微信联系人，最多40人
                      userIds: 'U2220360026;U2121431474;15928176773',
                      //参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
                      externalUserIds: 'wmckGjJwAAaj0mduv_wCOgImdzBt_w7A;wmckGjJwAAu6jRRyEIxN7R5lbi8XNQZQ',
                      // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
                      groupName: '讨论组',
                      // 会话名称。单聊时该参数传入空字符串""即可。
                      chatId: '',
                      // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
                      success: function success(res) {
                        chatIdText = res.chatId; //返回当前群聊ID，仅当使用agentConfig注入该接口权限时才返回chatId

                        console.log('群ID', res, chatIdText);
                        console.log('chatIdText', chatIdText);
                        wx.invoke('openExistedChatWithMsg', {
                          chatId: chatIdText,
                          msg: {
                            msgtype: 'text',
                            text: {
                              content: "你好"
                            }
                          }
                        }, function (res) {
                          if (res.err_msg == 'openExistedChatWithMsg:ok') {
                            console.log('打开会话成功');
                          }
                        });
                        // shareText()
                        // 回调
                      },
                      fail: function fail(res) {
                        console.log('失败', res);
                        if (res.errMsg.indexOf('function not exist') > -1) {
                          alert('版本过低请升级');
                        }
                      }
                    });
                  }
                }
              });
            },
            fail: function fail(err) {
              // console.log('AgentConfig注册失败', err)
              if (err.errMsg.indexOf('function not exist') > -1) {
                alert('版本过低请升级');
              }
            }
          });
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _shareText.apply(this, arguments);
}
export function shareImg(_x8, _x9, _x10) {
  return _shareImg.apply(this, arguments);
}

/**
 * @description:分享-H5发送
 * **/
function _shareImg() {
  _shareImg = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(item, type, code) {
    var entry, mediaid, itemStr, key, resData, timestamp, nonceStr, signature, corpId, AgentId;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          mediaid = item.mediaid;
          // console.log(mediaid, '临时素材Id')
          itemStr = '';
          for (key in item) {
            itemStr = "".concat(itemStr, "&").concat(key, "=").concat(item[key]);
          }
          _context6.next = 5;
          return initApi.getAgentConfig();
        case 5:
          resData = _context6.sent;
          // console.log('getAgentConfig接口响应数据', resData)
          timestamp = resData.timestamp, nonceStr = resData.nonceStr, signature = resData.signature, corpId = resData.corpId, AgentId = resData.AgentId;
          wx.agentConfig({
            corpid: corpId,
            agentid: AgentId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: JS_API_LIST,
            success: function success(data) {
              // console.log('AgentConfig注册成功', data)
              wx.checkJsApi({
                jsApiList: ['getContext', 'sendChatMessage'],
                // 需要检测的JS接口列表
                success: function success(res) {
                  // console.log('检测结果', res)
                  // 以键值对的形式返回，可用的api值true，不可用为false
                  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                  if (res.errMsg == 'checkJsApi:ok') {
                    wx.invoke('getContext', {}, function (res) {
                      // console.log('判断入口', res)
                      if (res.err_msg == 'getContext:ok') {
                        entry = res.entry; // 返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
                        // shareTicket = res.shareTicket // 可用于调用getShareInfo接口
                      } else {
                        // 错误处理
                      }
                    });
                    wx.invoke('sendChatMessage', {
                      msgtype: 'image',
                      // 消息类型，必填图片分享
                      enterChat: true,
                      // 为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
                      image: {
                        mediaid: mediaid //图片的素材id
                      }
                    }, function (res) {
                      // console.log('分享', res)
                      if (res.err_msg == 'sendChatMessage:ok') {
                        // 发送成功
                      }
                    });
                  }
                }
              });
            },
            fail: function fail(err) {
              // console.log('AgentConfig注册失败', err)
              if (err.errMsg.indexOf('function not exist') > -1) {
                alert('版本过低请升级');
              }
            }
          });
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _shareImg.apply(this, arguments);
}
export function shareList(_x11, _x12, _x13, _x14, _x15, _x16) {
  return _shareList.apply(this, arguments);
}

/**
 * @description:营销物料模块，分享文章-视频-问答到营销中心h5界面
 * @params{url}-分享对应页面的地址及参数
 * @params{type}-分享文件类型
 * @params{item}-当前点击分享的数据
 * **/
function _shareList() {
  _shareList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(item, path, type, code, event_sp, tipTitle) {
    var entry, shareTicket, title, contentText, imgUrl, itemStr, key, resData, timestamp, nonceStr, signature, corpId, AgentId;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          imgUrl = 'https://cdn.shupian.cn/sp/cms/crd79hndkh40000.png'; // 默认分享图片
          // console.log('item,', item)
          // console.log('path,', path)
          // console.log('type,', type)
          if (type == '文章详情') {
            title = item.title;
            contentText = item.contentText;
            imgUrl = item.imgUrl ? item.imgUrl : imgUrl;
          } else if (type == '文章列表') {
            title = item.title;
            imgUrl = item.imgUrl ? item.imgUrl : imgUrl;
            contentText = item.contentText ? item.contentText : '';
          } else if (type == '视频') {
            title = item.videoName;
            imgUrl = item.image;
            contentText = item.videoName;
          } else if (type == '问答') {
            title = item.title;
            contentText = item.title;
            imgUrl = item.contentImageUrl ? item.contentImageUrl : imgUrl;
          }
          itemStr = '';
          for (key in item) {
            itemStr = "".concat(itemStr, "&").concat(key, "=").concat(item[key]);
          }
          _context7.next = 6;
          return initApi.getAgentConfig();
        case 6:
          resData = _context7.sent;
          // console.log('getAgentConfig接口响应数据', resData)
          timestamp = resData.timestamp, nonceStr = resData.nonceStr, signature = resData.signature, corpId = resData.corpId, AgentId = resData.AgentId;
          wx.agentConfig({
            corpid: corpId,
            agentid: AgentId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: JS_API_LIST,
            success: function success(data) {
              // console.log('AgentConfig注册成功', data)
              wx.checkJsApi({
                jsApiList: ['getContext', 'sendChatMessage'],
                // 需要检测的JS接口列表
                success: function success(res) {
                  // console.log('检测结果', res)
                  // 以键值对的形式返回，可用的api值true，不可用为false
                  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                  if (res.errMsg == 'checkJsApi:ok') {
                    wx.invoke('getContext', {}, function (res) {
                      // console.log('判断入口', res)
                      if (res.err_msg == 'getContext:ok') {
                        entry = res.entry; // 返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
                        // shareTicket = res.shareTicket // 可用于调用getShareInfo接口
                      } else {
                        // 错误处理
                      }
                    });
                    var urlParam = "state=2&tipTile=".concat(tipTitle).concat(itemStr);
                    urlParam = encodeBase64(urlParam);
                    urlParam = encodeBase64(urlParam);
                    urlParam = encodeBase64(urlParam);
                    // console.log('-----------------' + urlParam)
                    var shareUrl = addressUrl + '#/' + path + '?params=' + urlParam;
                    wx.invoke('sendChatMessage', {
                      msgtype: 'news',
                      // 消息类型，必填
                      enterChat: true,
                      // 为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
                      news: {
                        link: shareUrl,
                        // H5消息页面url 必填
                        title: title,
                        // H5消息标题
                        desc: contentText,
                        // H5消息摘要
                        imgUrl: imgUrl // H5消息封面图片URL
                      }
                    }, function (res) {
                      // console.log('分享', res)
                      if (res.err_msg == 'sendChatMessage:ok') {
                        // 发送成功
                      }
                    });
                  }
                }
              });
            },
            fail: function fail(err) {
              // console.log('AgentConfig注册失败', err)
              if (err.errMsg.indexOf('function not exist') > -1) {
                alert('版本过低请升级');
              }
            }
          });
        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _shareList.apply(this, arguments);
}
export function shareYxwlPage(_x17, _x18, _x19, _x20, _x21, _x22, _x23, _x24, _x25, _x26, _x27) {
  return _shareYxwlPage.apply(this, arguments);
}

/***
 * @description：同步分享到客户朋友圈
 * **/
function _shareYxwlPage() {
  _shareYxwlPage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(url, type, item, path, eventSp, elementName, eventName, contentName, code, pageName, shareTypeSp) {
    var shareUrl, share_url_sp, entry, shareTicket, title, contentText, imgUrl;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          shareUrl = yxwlAddressShareUrl + url;
          share_url_sp = addressUrl + '#/' + path;
          imgUrl = 'https://cdn.shupian.cn/sp/cms/crd79hndkh40000.png'; // 默认分享图片
          if (type == '文章详情') {
            title = item.title;
            contentText = item.contentText;
            imgUrl = item.imgUrl ? item.imgUrl : imgUrl;
          } else if (type == '文章列表') {
            title = item.title;
            imgUrl = item.imgUrl ? item.imgUrl : imgUrl;
            contentText = item.contentText ? item.contentText : '';
          } else if (type == '视频列表') {
            title = item.videoName;
            imgUrl = item.image;
            contentText = item.videoName;
          } else if (type == '问答列表') {
            title = item.title;
            contentText = item.title;
            imgUrl = item.contentImageUrl ? item.contentImageUrl : imgUrl;
          }
          SPMDSDK.createShareUrl({
            share_url_sp: share_url_sp
          }).then(function (res) {
            // 获取到返回的json数据 案例如：
            console.log('埋点33信息', res);
            shareUrl = shareUrl + '&share_action_id_sp=' + res.data.share_action_id_sp + '&share_id_sp=' + res.data.share_id_sp;
            console.log('分享链接', shareUrl);
            SPMDSDK.spTrack({
              event_sp: eventSp,
              element_name_sp: elementName,
              event_name_sp: eventName,
              content_name_sp: contentName,
              page_name_sp: pageName,
              //页面名称
              track_code_sp: code,
              track_name_sp: elementName,
              content_type_sp: pageName,
              content_id_sp: item.id,
              is_share_type_sp: shareTypeSp ? shareTypeSp : '企业微信',
              share_action_id_sp: res.data.share_action_id_sp,
              // 分享动作id:唯一随机数
              is_share_action_id_sp: res.data.share_action_id_sp,
              // 分享动作id:唯一随机数
              share_id_sp: res.data.share_id_sp,
              // 分享id，如果用户登陆了就是用户id，未登录取值匿名id
              content_level_1_code_sp: item.oneClassificationId ? item.oneClassificationId : '',
              content_level_1_sp: item.oneClassification ? item.oneClassification : '',
              received_user_type_sp: '普通用户',
              received_user_id_sp: localStorage.getItem('externalUserId') //外部联系人ID
            }).then(function (res) {
              console.log('发送埋点成功', res);
              wx.invoke('sendChatMessage', {
                msgtype: 'news',
                // 消息类型，必填
                enterChat: true,
                // 为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
                news: {
                  link: shareUrl,
                  // H5消息页面url 必填
                  title: title,
                  // H5消息标题
                  desc: contentText,
                  // H5消息摘要
                  imgUrl: imgUrl // H5消息封面图片URL
                }
              }, function (res) {
                // console.log('分享成功', res)
                if (res.err_msg == 'sendChatMessage:ok') {
                  // 发送成功
                }
              });
            });
          }).catch(function (error) {
            // 上报失败后执行代码片段
            // console.log('分享失败', error)
          });
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _shareYxwlPage.apply(this, arguments);
}
export function shareCircleParents(_x28, _x29, _x30, _x31, _x32, _x33, _x34, _x35, _x36, _x37, _x38, _x39) {
  return _shareCircleParents.apply(this, arguments);
}

/**
 * @description:防抖
 * **/
function _shareCircleParents() {
  _shareCircleParents = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(url, type, item, path, eventSp, elementName, eventName, contentName, code, pageName, shareAna, shareTypeSp) {
    var title, contentText, imgUrl, allTitle, img, shareUrl, share_url_sp;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          console.log('分享语', shareAna);
          img = 'https://sp-crm-1258378054.cos.ap-chengdu.myqcloud.com/%E8%96%AF%E7%89%87log.jpg';
          shareUrl = yxwlAddressShareUrl + url;
          share_url_sp = addressUrl + '#/' + path;
          if (type == '文章列表') {
            title = item.title;
            imgUrl = item.imgUrl ? item.imgUrl : img;
            contentText = item.contentText ? item.contentText : '';
          } else if (type == '视频列表') {
            title = item.videoName;
            imgUrl = item.image;
            contentText = item.videoName;
          } else if (type == '问答列表') {
            title = item.title;
            contentText = item.title;
            imgUrl = item.contentImageUrl ? item.contentImageUrl : img;
          }
          SPMDSDK.createShareUrl({
            share_url_sp: share_url_sp
          }).then(function (res) {
            shareUrl = shareUrl + '&share_action_id_sp=' + res.data.share_action_id_sp + '&share_id_sp=' + res.data.share_id_sp;
            console.log('分享链接', shareUrl);
            // 获取到返回的json数据 案例如：
            // console.log('朋友圈埋点信息', res)

            SPMDSDK.spTrack({
              event_sp: eventSp,
              element_name_sp: elementName,
              event_name_sp: eventName,
              content_name_sp: contentName,
              page_name_sp: pageName,
              //页面名称
              track_code_sp: code,
              track_name_sp: elementName,
              content_type_sp: type,
              content_id_sp: item.id,
              is_share_type_sp: shareTypeSp ? shareTypeSp : '企业微信',
              share_action_id_sp: res.data.share_action_id_sp,
              // 分享动作id:唯一随机数
              is_share_action_id_sp: res.data.share_action_id_sp,
              // 分享动作id:唯一随机数
              share_id_sp: res.data.share_id_sp,
              // 分享id，如果用户登陆了就是用户id，未登录取值匿名id
              content_level_1_code_sp: item.content_level_1_code_sp ? item.content_level_1_code_sp : '',
              content_level_1_sp: item.content_level_1_sp ? item.content_level_1_sp : '',
              content_level_2_sp: item.content_level_2_sp ? item.content_level_2_sp : '',
              content_level_2_code_sp: item.content_level_2_code_sp ? item.content_level_2_code_sp : '',
              received_user_type_sp: '普通用户',
              received_user_id_sp: localStorage.getItem('externalUserId') //外部联系人ID
            }).then(function (res) {
              console.log('发送埋点成功', res);
            });
            if (type != '海报') {
              if (title.length > 20) {
                allTitle = title.slice(0, 20);
              } else {
                allTitle = title;
              }
              wx.invoke("shareToExternalMoments", {
                text: {
                  content: shareAna // 文本内容
                },
                attachments: [{
                  msgtype: "link",
                  // 消息类型，必填
                  link: {
                    title: allTitle,
                    // H5消息标题
                    imgUrl: img,
                    // H5消息封面图片URL
                    url: shareUrl // H5消息页面url 必填
                  }
                }]
              }, function (res) {
                // console.log('朋友圈信息',res)
                if (res.err_msg == "shareToExternalMoments:ok") {}
              });
            } //
            else {
              console.log('海报url', url);
              console.log('海报type', type);
              console.log('海报item', item);
              var mediaid = item.mediaid;
              wx.invoke("shareToExternalMoments", {
                text: {
                  content: shareAna // 文本内容
                },
                attachments: [{
                  msgtype: "image",
                  // 消息类型，必填
                  image: {
                    mediaid: mediaid,
                    // 图片的素材id
                    imgUrl: "" // 图片的imgUrl,跟图片mediaid填其中一个即可
                  }
                }]
              }, function (res) {
                // console.log('海报朋友圈信息11',res)
                if (res.err_msg == "shareToExternalMoments:ok") {}
              });
            }
          }).catch(function (error) {
            // 上报失败后执行代码片段
            console.log('朋友圈信息', error);
          });
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _shareCircleParents.apply(this, arguments);
}
export var debounce = function () {
  var timer = null;
  return function (callback, wait) {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
}();

/***
 * @description:等比缩放图片
 * **/
export function AutoResizeImage(maxWidth, maxHeight, objImg) {
  var img = new Image();
  img.src = objImg.src;
  var hRatio;
  var wRatio;
  var Ratio = 1;
  var w = img.width;
  var h = img.height;
  wRatio = maxWidth / w;
  hRatio = maxHeight / h;
  if (maxWidth == 0 && maxHeight == 0) {
    Ratio = 1;
  } else if (maxWidth == 0) {
    //
    if (hRatio < 1) Ratio = hRatio;
  } else if (maxHeight == 0) {
    if (wRatio < 1) Ratio = wRatio;
  } else if (wRatio < 1 || hRatio < 1) {
    Ratio = wRatio <= hRatio ? wRatio : hRatio;
  }
  if (Ratio < 1) {
    w = w * Ratio;
    h = h * Ratio;
  }
  objImg.height = h;
  objImg.width = w;
}

/**
 * @description:根据不同的设备入口判断对应的设备登录
 * **/
export function deviceLogin() {
  // 获取初始信息
  var app = navigator.appVersion;
  //    根据括号进行分割
  var left = app.indexOf('(');
  var right = app.indexOf(')');
  var str = app.substring(left + 1, right);
  var Str = str.split(';');
  // 手机型号--苹果 iPhone
  var Mobile_Iphone = Str[0];
  // console.log(str + '设备型号')
  // console.log('设备', Mobile_Iphone.includes('Windows'))
  // console.log('mac型号', Mobile_Iphone.includes('mac'))
  var windows = Mobile_Iphone.includes('Windows');
  var mac = Mobile_Iphone.includes('Mac');
  var dictionLogin = false; //true-电脑端登录,false手机端登录

  if (windows || mac) {
    dictionLogin = true;
  } else {
    dictionLogin = false;
  }
  sessionStorage.setItem('deviceMsg', str);
  return dictionLogin;

  // // 手机型号--安卓
  //   let Mobile_Android=Str[2];
  //   // 红米手机等特殊型号处理 匹配字符
  //   let res=/Android/;
  //   let reslut=res.test(Mobile_Android);
  // // 根据设备型号判断设备系统
  // //   if(phoneVersion=='iPhone'){
  // //     console.log('访问设备型号'+Mobile_Iphone+'系统版本'+Str[1].substring(4,19));
  // //   }else if(phoneVersion=='Linux'){
  // //     if(reslut){
  // //       console.log('访问设备型号'+Str[4].substring(0,9)+'系统版本'+Str[2]);
  // //     }else{
  // //       console.log('访问设备型号'+Mobile_Android.substring(0,9)+'系统版本'+Str[1]);
  // //     }
  // //   }else if(phoneVersion=='iPad'){
  // //     console.log('访问设备'+Str[0]+'系统版本'+Str[1].substring(4,12));
  // //   }
}

/**
 * @description：分享小程序
 * @params:{appid}-小程序ID
 * @params:{title}-小程序分享标题
 * @params:{imgUrl}-小程序分享封面图
 * @params:{page}-小程序分享路径
 * @params:{type}-区分小程序Id 'order'为订单小程序, 'card'为智能名片小程序
 * **/
export function sharePrograme(type, title, page, img, options) {
  console.log('订单appid', wxAppId);
  console.log('智能名片appid', mpAppId);
  console.log('title', title);
  console.log('page', page);
  var appid = '';
  var imgUrl = "https://sp-crm-1258378054.cos.ap-chengdu.myqcloud.com/%E8%96%AF%E7%89%87log.jpg"; //此图为发送订单小程序的默认图片
  if (type === 'order') {
    appid = wxAppId;
  } else if (type === 'card') {
    appid = mpAppId;
  } else if (type === 'newDgg') {
    appid = newWxAppId;
  }
  if (img) {
    imgUrl = img;
  }
  // 评价邀约可指定后端返回的AppID；其他业务仍按原type取值。
  if (options && options.appId) appid = options.appId;
  console.log('img', imgUrl);
  return new Promise(function (resolve, reject) {
    wx.checkJsApi({
      jsApiList: ['getContext', 'sendChatMessage'],
      // 需要检测的JS接口列表
      success: function success(res) {
        console.log('检测结果', res);
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        if (res.errMsg == 'checkJsApi:ok') {
          wx.invoke('getContext', {}, function (res) {
            console.log('判断入口', res);
            if (res.err_msg == 'getContext:ok') {
              // entry = res.entry // 返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
              // shareTicket = res.shareTicket // 可用于调用getShareInfo接口
            } else {
              // 错误处理
            }
          });
          wx.invoke('sendChatMessage', {
            msgtype: "miniprogram",
            //消息类型，必填
            enterChat: true,
            //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
            miniprogram: {
              appid: appid,
              //小程序的appid，企业已关联的任一个小程序
              title: title,
              //小程序消息的title
              imgUrl: imgUrl,
              //小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
              page: page //小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
            }
          }, function (obj) {
            console.log('分享小程序', obj);
            if (options && options.onResult) options.onResult(obj);
            if (obj.err_msg == 'sendChatMessage:ok') {
              //发送成功
              console.log(res, '分享小程序');
              resolve(res);
            }
          });
        } else if (options && options.onResult) {
          options.onResult(res);
        }
      },
      fail: function fail(error) {
        if (options && options.onResult) options.onResult(error);
      }
    });
  });
}

/**
 * @description：分享小程序
 * @params:{appid}-小程序ID
 * @params:{type}-区分小程序Id 'order'为订单小程序, 'card'为智能名片小程序
 * @params:{path}-小程序路径
 * @params:{flag}-flag为true,则关闭当前H5页面
 * **/
export function toPrograme(type, path, flag) {
  var appid = '';
  if (type === 'order') {
    appid = wxAppId;
  } else if (type === 'card') {
    appid = mpAppId;
  }
  console.log(appid, 'appid');
  wx.checkJsApi({
    jsApiList: ['launchMiniprogram'],
    // 需要检测的JS接口列表

    success: function success(res) {
      console.log('检测结果', res);
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      if (res.errMsg == 'checkJsApi:ok') {
        wx.invoke('launchMiniprogram', {
          "appid": "".concat(appid),
          // 需跳转的小程序appid
          "path": "".concat(path) // 所需跳转的小程序内页面路径及参数。非必填
        }, function (res) {
          console.log('跳转小程序', res);
          console.log(appid, 'appid');
          if (res.err_msg == "launchMiniprogram:ok") {
            // 正常
          } else {
            // 错误处理
          }
        });
      }

      // if(flag) {
      //   setTimeout(() => {
      //     wx.closeWindow()
      //   }, 2000);
      // }
    }
  });

  // if(flag) {
  //   wx.closeWindow()
  // }
}

/**
 * @description:同步分享合同给客户
 * **/
export function shareContract(_x40, _x41, _x42) {
  return _shareContract.apply(this, arguments);
}

/**
 * @description:分享文件pdf/ppt/xls/excel
 * **/
function _shareContract() {
  _shareContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(title, ids, customerName) {
    var url;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          // let url = 'https://dm.shupian.cn/signcontract/contract/details?ids=%255B%25222199236876435364301%2522%255D'
          url = contractShareUrl + 'signcontract/contract/details?ids=' + ids + '&pageName=SCRM';
          console.log('分享地址', url);
          wx.invoke('sendChatMessage', {
            msgtype: "news",
            //消息类型，必填
            enterChat: true,
            //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
            news: {
              link: url,
              //H5消息页面url 必填
              title: '合同编号:' + title,
              //H5消息标题
              desc: '签署人:' + customerName,
              //H5消息摘要
              imgUrl: "https://sp-crm-1258378054.cos.ap-chengdu.myqcloud.com/%E8%96%AF%E7%89%87log.jpg" //H5消息封面图片URL
            }
          }, function (obj) {
            console.log('分享小程序', obj);
            if (obj.err_msg == 'sendChatMessage:ok') {
              //发送成功
            }
          });
        case 3:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _shareContract.apply(this, arguments);
}
export function shareWechatFile(_x43, _x44) {
  return _shareWechatFile.apply(this, arguments);
}

/**
 * @description:预览文件
 * @params{type}-文件类型
 * @params{fileUrl}-文件地址
 * @params{item}-当前选中文件参数
 * **/
function _shareWechatFile() {
  _shareWechatFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(id, title) {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          wx.invoke('sendChatMessage', {
            msgtype: "file",
            //消息类型，必填
            enterChat: true,
            //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
            text: {
              content: title //文本内容
            },
            file: {
              mediaid: id //文件的素材id
            }
          }, function (obj) {
            console.log('分享文件', obj);
            if (obj.err_msg == 'sendChatMessage:ok') {
              //发送成功
            }
          });
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _shareWechatFile.apply(this, arguments);
}
export function perViewFile(_x45, _x46, _x47, _x48) {
  return _perViewFile.apply(this, arguments);
}

/**
 * 预览pdf
 * **/

/**

 * 预览文档

 * @param src 文档地址，如：https://view.xdocin.com/demo/view.docx

 * @param ops 预览选项

 * @param target 预览容器，DOM元素或者DOM元素ID

 */
function _perViewFile() {
  _perViewFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(type, fileUrl, item, size) {
    var url;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          url = fileUrl; // pdf 判定优先取显式传入的 type（previewFileBySource 已显式指定 fileType 时不依赖 url 后缀），
          // url 以 .pdf 结尾兜底（其余调用方 type 与后缀本就一致，行为不变）
          if (type === 'pdf' || url.endsWith('.pdf')) {
            // PDF 预览
            preview(fileUrl);

            // window.open(url,"_blank", "height=800, width=800, top=50, left=50, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no")
            // window.open("https://view.xdocin.com/xdoc?_xdoc=" + encodeURIComponent(url), "_blank", "height=800, width=800, top=50, left=50, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
          } else {
            // 微软或者其它的预览方式
            window.open("http://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(url), "_blank", "height=800, width=800, top=50, left=50, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
          }
        case 2:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _perViewFile.apply(this, arguments);
}
export function preview(src, ops, target) {
  console.log('文件预览');
  var xurl = "https://view.xdocin.com/view?src=";
  xurl += encodeURIComponent(src);

  //预览参数

  var ops = {
    "pdf": true,
    //word文档尝试以pdf方式显示，默认false

    "watermark": "文档预览",
    //水印文本，显示水印

    "saveable": true,
    //是否允许保存源文件，默认false

    "printable": true,
    //是否允许打印，默认true

    "copyable": true,
    //是否允许选择复制内容，默认true

    "toolbar": true,
    //是否显示底部工具条，默认true

    "title": "文档预览",
    //自定义标题

    // "expire": 30, //预览链接有效期，单位分钟，默认永久有效

    "limit": "1,200" //限制页数，如：“5”表示只显示前5页，“2,5”表示从第2页开始的5页，对pdf/doc/docx/ppt/pptx有效

    // "mtime": 1633093801, //文件修改时间戳（精确到秒）或修改时间（如：2021-10-01 21:10:01），值改变刷新缓存，实时预览
  };
  if (ops) {
    for (var a in ops) {
      xurl += "&" + a + "=" + encodeURIComponent(ops[a]);
    }
  }
  if (target) {
    var parent = null;
    if (typeof target == "string") {
      parent = document.getElementById(target);
    } else if (target instanceof Element) {
      parent = target;
    }
    if (parent) {
      parent.innerHTML = "";
      var ele = document.createElement("iframe");
      var att = document.createAttribute("frameborder");
      att.value = "0";
      ele.setAttributeNode(att);
      att = document.createAttribute("style");
      att.value = "width:100%;height:100%;";
      ele.setAttributeNode(att);
      parent.appendChild(ele);
      att = document.createAttribute("src");
      att.value = xurl;
      ele.setAttributeNode(att);
      return;
    }
  }
  window.open(xurl, "_blank", "height=800, width=800, top=50, left=50, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
}

/**
 * @description: 按来源与格式校验并预览文件（公共方法，多个页面复用）
 * 预览规则：来源为 wx（企微侧边栏）时仅支持预览图片类型；其余来源支持图片与 pdf 类型；
 *           不满足的类型统一提示——小程序/wx 来源提示「预览文件受限，请到APP进行查看」，
 *           其余来源提示「暂不支持该格式预览」
 * 图片预览：vant ImagePreview 函数式调用（全屏查看，与 preview-file 组件行为一致）；
 * pdf 预览：复用 perViewFile → xdocin 在线预览（新窗口打开）
 * @param {Object} options
 * @param {String} options.url 文件地址（必填；从地址最后一个 . 后截取扩展名判断格式）
 * @param {String} options.source 入口来源（wx/ios/android/qw/pc；不传时按环境自检兜底：
 *                                 微信小程序 web-view 或 source=wx 仅图片，其余图片 + pdf）
 * @param {String} [options.fileName] 文件名（可选，日志排查用）
 * @param {String} [options.fileType] 显式文件类型（可选：原始后缀或归类值均可，如接口 fileSuffix
 *                                    字段的 jpg/pdf 或已归类 image/pdf；内部统一过 FileTypeDeal
 *                                    归一化，不依赖 url 后缀推断——previewUrl 类地址无真实后缀）
 * @returns {Boolean} 是否执行了预览（参数缺失/类型不支持为 false）
 */
export function previewFileBySource() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    url = _ref4.url,
    source = _ref4.source,
    fileName = _ref4.fileName,
    fileType = _ref4.fileType;
  if (!url) {
    _Toast('未获取到文件地址，暂不支持预览');
    return false;
  }
  var dealSuffix = function dealSuffix(suffix) {
    return FileTypeDeal(String(suffix || '').replace(/^\./, '').toLowerCase());
  };
  var type = fileType ? dealSuffix(fileType) : '';
  if (!type) {
    var path = String(url);
    var idx = path.lastIndexOf('.');
    var suffix = idx > -1 && idx < path.length - 1 ? path.slice(idx + 1).toLowerCase() : '';
    type = FileTypeDeal(suffix);
  }
  // 可预览类型按环境判定：微信小程序 web-view 仅图片——pdf 在线预览走 window.open 新开窗口，
  // 小程序原生容器不支持新开窗口（点击无响应），非图片类型直接提示引导到 APP 查看；
  // 判断双保险：环境自检（__wxjs_environment / UA 含 miniprogram，与 customer-library mixins
  // 的 isMiniProgram 同口径，兜底 source 未传/透传丢失的场景）+ source === 'wx'
  // （uniapp 小程序容器跳转携带的来源值）；其他来源（qw/pc/ios/android）图片 + pdf
  var isMiniProgram = typeof window !== 'undefined' && (window.__wxjs_environment === 'miniprogram' || /miniprogram/i.test(window.navigator.userAgent || ''));
  var allowTypes = isMiniProgram || source === 'wx' ? ['image'] : ['image', 'pdf'];
  console.log('文件预览', type, allowTypes);
  if (!allowTypes.includes(type)) {
    // 小程序/wx 来源仅支持图片，其余格式引导用户到 APP 查看；其他来源（pdf 亦不支持时）保持原提示
    _Toast(isMiniProgram || source === 'wx' ? '预览文件受限，请到APP进行查看' : '暂不支持该格式预览');
    return false;
  }
  if (type === 'image') {
    _ImagePreview({
      images: [url],
      closeable: true,
      showIndex: false,
      maxZoom: 10
    });
    return true;
  }
  // pdf：路由跳转到 PdfViewer 页面，通过 canvas 渲染兼容 App 端
  var query = {
    url: url,
    source: source
  };
  var statusBarHeight = sessionStorage.getItem('statusBarHeight');
  if (statusBarHeight) query.statusBarHeight = statusBarHeight;
  router.push({
    path: '/PdfViewer',
    query: query
  });
  return true;
}

/**
 * @description:判断入口环境
 *@return{single_chat_tools}-单聊
 * @return{group_chat_tools}-群聊
 * **/
export function getcontextFunc() {
  var entry, shareTicket;
  wx.invoke('getContext', {}, function (res) {
    console.log('判断商机线索页面入口环境', res);
    if (res.err_msg == "getContext:ok") {
      entry = res.entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment

      //一对一单聊
      if (res.entry == 'single_chat_tools') {
        console.log('一对一单聊');
      }
      //群聊会话
      else if (res.entry == 'group_chat_tools') {
        console.log('群聊会话进入');
      }

      //会话的聊天附件栏进入
      else if (res.entry == 'chat_attachment') {
        console.log('会话聊天附件栏');
      }
      shareTicket = res.shareTicket; //可用于调用getShareInfo接口
    } else {
      //错误处理
    }
  });
  return entry;
}

/**
 * @description:分享h5链接
 * @params:分享链接地址
 * **/
export function shareH5File(title, link, desc, imgUrl, onResult) {
  wx.invoke('sendChatMessage', {
    msgtype: "news",
    //消息类型，必填
    enterChat: true,
    //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段

    news: {
      link: link,
      //H5消息页面url 必填
      title: title ? title : '',
      //H5消息标题
      desc: desc ? desc : '',
      //H5消息摘要
      imgUrl: imgUrl ? imgUrl : 'https://sp-crm-1258378054.cos.ap-chengdu.myqcloud.com/%E8%96%AF%E7%89%87log.jpg' //H5消息封面图片URL
    }
  }, function (res) {
    console.log('发送信息', res);
    if (onResult) onResult(res);
    if (res.err_msg == 'sendChatMessage:ok') {
      //发送成功
    }
  });
}

/**
 * @description:分享文本消息
 * **/
export function shareContent(_x49) {
  return _shareContent.apply(this, arguments);
}

/**
 * @description:分享跳转到群应用并发送消息
 * **/
function _shareContent() {
  _shareContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(content) {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          console.log(content);
          wx.invoke('sendChatMessage', {
            msgtype: "text",
            //消息类型，必填
            enterChat: true,
            //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
            text: {
              content: content //文本内容
            }
          }, function (obj) {
            if (obj.err_msg == 'sendChatMessage:ok') {
              //发送成功
              console.log('发送成功');
            }
          });
        case 2:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _shareContent.apply(this, arguments);
}
export function shareGroupMsg(_x50) {
  return _shareGroupMsg.apply(this, arguments);
}

/**
 * @description:复制方法
 * **/
function _shareGroupMsg() {
  _shareGroupMsg = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(val) {
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          wx.invoke("openExistedChatWithMsg", {
            chatId: "wrckGjJwAAOlTeFeNKzcjDCNils4kSCg",
            msg: {
              msgtype: "link",
              link: {
                title: 'xxx产品服务进度',
                desc: '您的xx服务已接单，将在最快的时间为您办理',
                url: "https://tm-crm.shupian.net/#/ifream-test",
                imgUrl: "https://sp-crm-1258378054.cos.ap-chengdu.myqcloud.com/%E8%96%AF%E7%89%87log.jpg"
              }
            }
          }, function (res) {
            console.log('分享消息', res);
            if (res.err_msg == "openExistedChatWithMsg:ok") {}
          });
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _shareGroupMsg.apply(this, arguments);
}
export function handleCopy(_x51) {
  return _handleCopy.apply(this, arguments);
}

/**
 * @description 将文件后缀定义为组件对文件格式的定义：组件对格式的定义划分为：image\pdf\xls\ppt\doc
 * @param suffix String 文件后缀
 * @returns String 返回组件对文件格式的定义：image\pdf\xls\ppt\doc
 */
function _handleCopy() {
  _handleCopy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(value) {
    var input;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          // 创建input标签
          input = document.createElement('input'); // 将input的值设置为需要复制的内容
          input.value = value;
          console.log('input', input);
          input.readOnly = "readOnly";
          input.style.position = "absolute";
          input.style.top = "0px";
          input.style.zIndex = "-1000";
          // 添加input标签
          document.body.appendChild(input);

          // 选中input标签
          input.select();
          // 执行复制
          document.execCommand('copy');
          // 移除input标签
          document.body.removeChild(input);
          _Toast('复制成功');
        case 12:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _handleCopy.apply(this, arguments);
}
export function FileTypeDeal(suffix) {
  suffix = suffix.toLowerCase();
  switch (suffix) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
      return 'image';
    case 'xls':
    case 'xlsx':
      return 'xls';
    case 'doc':
    case 'docx':
      return 'doc';
    case 'ppt':
    case 'pptx':
      return 'ppt';
    case 'mp3':
    case 'wav':
    case 'm4a':
    case 'amr':
    case 'aac':
    case 'ogg':
    case 'flac':
    case 'awb':
    case 'wma':
      return 'audio';
    case 'mp4':
    case 'rmvb':
      return 'video';
    case 'pdf':
      return 'pdf';
    case 'rar':
    case 'zip':
    case '7z':
    case 'gz':
    case 'tar':
    case 'bz2':
    case 'xz':
      return 'zip';
    default:
      return suffix;
  }
}